const voicemailmessagecsvcolumndata = [
  { id: "read_epoch", title: "Status", default: true },
  { id: "caller_id_name", title: "Caller", default: true },
  { id: "caller_id_number", title: "Number", default: true },
  { id: "created_epoch", title: "Date", default: true },
  { id: "message_length", title: "Duration" },
  { id: "player", title: "Preview", default: true },
];
export default voicemailmessagecsvcolumndata;
